










import Vue from 'vue'

/**
 * ツールチップ コンポーネント
 */
export default Vue.extend({
  name: 'SimpleTooltip',
  props: {
    tooltipText: String,
  },
  data() {
    return {
      visible: false,
      left: '',
    }
  },
  watch: {
    visible() {
      if (!this.visible) {
        return;
      }

      this.$nextTick(function () {
        this.tooltipPositioner();
      });
    },
  },
  methods: {
    tooltipPositioner() {
      var tooltipSubject = this.$el.clientWidth;
      var tooltipTextWidht = 0;
      var tooltipPosition = 0;

      if (!this.$refs.tooltipTextRef) {
        return;
      }

      // @ts-ignore
      tooltipTextWidht = this.$refs.tooltipTextRef.offsetWidth;

      tooltipPosition = (((tooltipTextWidht / 2) - (tooltipSubject - 10)) * -1);

      if (tooltipPosition > 0) {
        this.left = (tooltipPosition / 2) + 'px';
        return;
      }

      this.left = tooltipPosition + 'px';
    },
  },
})
